import React, { useEffect, useState } from "react";
import Navbar from "../NavBar/Navbar";
import "./EmployeeDashboard.css";
import FadeLoader from "react-spinners/FadeLoader";
import manager from './Employee.png'
import EmployeeRegistration from "./EmployeeRegistration";
import { useUser } from "../utils/UserContext.jsx";
import EmployeeList from "./EmployeeListInfo.jsx";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import { deleteEmployeeWithAllData } from '../../Services/ManagerService.jsx'

import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';

const ManagerDashboard = () => {

    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

    const [loader, setLoader] = useState(false)
    const [registerEmployee, setRegisterEmployee] = useState(false)
    const [isEdit] = useState(false);
    const [employeeEmailId, setEmployeeEmailId] = useState(null)
    const [employeeName, setEmployeeName] = useState(null)
    const [open, setOpen] = useState(false);
    const [empId, setempId] = useState(null);
    const [empRegistrationIdToDelete, setEmpRegistrationIdToDelete] = useState(null);
    const [empb2cId, setEmpb2cId] = useState()
    const [empRegistrationId, setEmpRegistrationId] = useState()
    const [, setSalesperson] = useState();
    const [ownerId, setOwnerId] = useState();
    const [employeeDetails, setEmployeeDetails] = useState([]);
    const { userDetails } = useUser();
    const [apiCalled, setApiCalled] = useState(false);



    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userData = await GetUserDetailsFromToken();
                setSalesperson(userData?.firstName);
                setOwnerId(userData?.empId);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
        fetchUserData();
    }, []);


    const handleRegisterEmployee = (e, val, email, empRegistrationId, empId) => {
        console.log("34324", { val, email, empRegistrationId, empId });

        if (e) e.stopPropagation();
        setRegisterEmployee(val)
        setEmpb2cId(empId);
        console.log("emplregiagtraionid", empRegistrationId);

        setEmpRegistrationId(empRegistrationId)
        setEmployeeEmailId(email)

    }

    const fetchEmployeeDetails = async () => {
        if (!userDetails?.entityRegistrationID) {
            console.warn("Missing EntityRegistrationID.");
            return;
        }

        setLoader(true);
        try {
            const response = await fetch(`${hostPath}/api/GetEmpdetailsbyOwner`, {
                method: 'POST',
                headers: {
                    "x-functions-key": hostHeader,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ entityRegistrationID: userDetails.entityRegistrationID })

            });
            if (!response.ok) {
                if (response.status === 404) {
                    setEmployeeDetails([]); // No data found, return empty array
                    return;
                }
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log("data", data);

            setEmployeeDetails(data);
            setApiCalled(true); // API call completed
        } catch (error) {
            console.error("Failed to fetch parking lot details:", error);
            setEmployeeDetails([]); // Ensure UI resets on failure
        } finally {
            setLoader(false); // Ensures loader stops in all cases
        }
    };
    useEffect(() => {
        fetchEmployeeDetails();
    }, [hostPath, userDetails]);

    const handleDelete = (e, val) => {
        if (e) { e.stopPropagation(); }

        setEmployeeEmailId(val?.emailId);
        setEmployeeName(val?.firstName);
        setOpen(true);
        setempId(val?.empId ?? null);
        setEmpRegistrationIdToDelete(val?.empRegistrationID ?? null);
    };
    const handleConfirm = async (name, emailId, empId, empRegistrationID) => {
        if (name === 'confirm') {
            try {
                setLoader(true);
                const result = await deleteEmployeeWithAllData(emailId, empId, empRegistrationID);
                if (result.success) {
                    setOpen(false);
                    setEmpRegistrationIdToDelete(null);
                    await fetchEmployeeDetails();
                } else {
                    alert(result.message || 'Failed to delete employee.');
                }
            }
            catch (error) {
                console.error("Error during deletion:", error);
                alert(error.message || 'Failed to delete employee and associated data.');
            }
            finally {
                setLoader(false);
            }
        }
        if (name === 'cancel') {
            setLoader(false)
             setOpen(false);
             setEmpRegistrationIdToDelete(null);
        }
    }

    return (
        <div className="manager-main ">
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            <Navbar />
            {registerEmployee && !loader ? (
                <EmployeeRegistration
                    registerEmployee={registerEmployee}
                    handleRegisterEmployee={handleRegisterEmployee}
                    empb2cId={empb2cId}
                    ownerId={ownerId}
                    userDetails={userDetails}
                    employeeEmailId={employeeEmailId}
                    empRegistrationId={empRegistrationId}
                    refreshEmployees={fetchEmployeeDetails} // ✅ pass this down
                />

            ) : employeeDetails && employeeDetails.length > 0 ? (
                <EmployeeList employeeDetails={employeeDetails} handleRegisterEmployee={handleRegisterEmployee} handleDelete={handleDelete} handleEdit={handleRegisterEmployee} />
            ) : (
                !isEdit && apiCalled && (
                    <div>
                        <div className="container-fluid p-0">
                            <div className="manager-dashboard">
                                <div className="row Manager-title-container pb-7">
                                    <div className="col-8">
                                        <div className="manager-title">Employees</div>
                                        <div className="manager-title-content mt-2">
                                            Add and manage sub-owners who can help you manage your parking properties.
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            src={manager}
                                            alt="Manager dashboard illustration showing employee management"
                                            className="manager-image"
                                        />
                                    </div>
                                </div>

                                <div className="row p-3">
                                    <div className="col-12 d-flex justify-content-center">
                                        <p className="text-center manager-content">
                                            You haven't added any sub-owners yet.
                                            Sub-owners can help you manage your parking lots and earnings.
                                        </p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="add-button-manager d-flex justify-content-center">
                                        <button
                                            className="btn btn-primary"
                                            onClick={(e) => handleRegisterEmployee(e, true)}
                                            type="button"
                                            aria-label="Add new employees to help manage parking properties"
                                        >
                                            Add New Employees
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )
            )}
            <Dialog
                classes={{ paper: 'custom-paper-class-delete' }}
                aria-labelledby="customized-dialog-title"
                dividers
                open={open}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <DialogTitle dividers sx={{ textAlign: 'start', color: "#000", fontSize: "24px", fontWeight: "700", padding: "5px 24px" }} id="customized-dialog-title">
                    Are you Sure You Want to Delete This {employeeName} Employee?
                </DialogTitle>
                <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000" }}>
                    <Typography>
                        <span>If you delete this employee, all parking lots and related data associated with this employee will be deleted.</span>
                    </Typography>
                    <Typography gutterBottom>
                        <span>This action is irreversible. Please confirm if you wish to proceed.</span>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'right' }}>
                    <Button className='custom-button-cancel' onClick={() => handleConfirm('cancel')}>Cancel</Button>
                    <Button className='custom-button-delete' onClick={() => handleConfirm('confirm', employeeEmailId, empId, empRegistrationIdToDelete)}>Delete</Button>
                </DialogActions>
            </Dialog>


        </div>


    );
};

export default ManagerDashboard;
